export default {
  adminUsers: [],
};
